/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_DestinationInputs */

const en_field_destination = /** @type {(inputs: Field_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destination`)
};

const es_field_destination = /** @type {(inputs: Field_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destino`)
};

const fr_field_destination = /** @type {(inputs: Field_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destination`)
};

const de_field_destination = /** @type {(inputs: Field_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiseziel`)
};

const ja_field_destination = /** @type {(inputs: Field_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目的地`)
};

const zh_field_destination = /** @type {(inputs: Field_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目的地`)
};

const ar_field_destination = /** @type {(inputs: Field_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوجهة`)
};

const id_field_destination = /** @type {(inputs: Field_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destinasi`)
};

const it_field_destination = /** @type {(inputs: Field_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destinazione`)
};

const ru_field_destination = /** @type {(inputs: Field_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Место назначения`)
};

const pt_field_destination = /** @type {(inputs: Field_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destino`)
};

const ko_field_destination = /** @type {(inputs: Field_DestinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`목적지`)
};

/**
* | output |
* | --- |
* | "Destination" |
*
* @param {Field_DestinationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_destination = /** @type {((inputs?: Field_DestinationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_DestinationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_destination(inputs)
	if (locale === "es") return es_field_destination(inputs)
	if (locale === "fr") return fr_field_destination(inputs)
	if (locale === "de") return de_field_destination(inputs)
	if (locale === "ja") return ja_field_destination(inputs)
	if (locale === "zh") return zh_field_destination(inputs)
	if (locale === "ar") return ar_field_destination(inputs)
	if (locale === "id") return id_field_destination(inputs)
	if (locale === "it") return it_field_destination(inputs)
	if (locale === "ru") return ru_field_destination(inputs)
	if (locale === "pt") return pt_field_destination(inputs)
	return ko_field_destination(inputs)
});